<template>
    <div
        id="list-lastInvoiceStatuses-component"
        class="w-full h-full flex flex-col"
    >
        <custom-simple-select
            v-model="option"
            class="w-full"
            label="Estado de factura"
            :options="lastInvoiceStatusOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { lastInvoiceStatusesCodes } from "@/common/fields/platform-subscription-codes";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "LastInvoiceStatusSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: ""
    }),
    computed: {
        lastInvoiceStatusOptions() {
            return Object.entries(lastInvoiceStatusesCodes).map(
                ([key, value]) => ({
                    label: value,
                    value: key
                })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
